module.exports = __webpack_public_path__ + "img/partner-provokateur.4db16fd7.webp";